import React, { useState } from 'react';

import { Image, Icon, Popup, Transition } from 'semantic-ui-react'


import { Hero, ActionType, TierConverter } from '../types'
import { PlayerDraftCardProps } from '../playerDraftCard'

import ConfirmModal from '../../tour/utils/ConfirmModal';

import { getHeroImage } from './useHeroes';
import { useMeleeContext } from 'draft/context/MeleeContextProvider';

interface Props {
    Hero: Hero,
    cardProps?: PlayerDraftCardProps,
    Banned?: boolean
}

export default function HeroImage(props: Props) {
    const context = useMeleeContext();
    const [selfBanModalOpen, setSelfBanModalOpen] = useState(false);
    const [shakeAnimation, setShakeAnimation] = useState(true);

    if (!props.Hero) {
        return <p>Error</p>;
    }

    const banHero = () => {
        props.cardProps && props.cardProps.applyHeroAction!(props.cardProps.player!, props.Hero, ActionType.Ban);
        props.cardProps!.executeAction!();
    }

    const pickHero = () => {
        props.cardProps && props.cardProps.applyHeroAction!(props.cardProps.player!, props.Hero, ActionType.Pick);
        props.cardProps!.executeAction!();
    }

    let banned = props.Banned;

    function OnClick() {
        if (props.cardProps!.player!.PickedHero || (props.cardProps!.currentAction!.Action !== ActionType.Pick && props.cardProps!.currentAction!.Action !== ActionType.Ban))
            return;

        if (banned) {
            setShakeAnimation(!shakeAnimation); //Spiller shake animation
            return;
        }

        if (props.cardProps!.currentAction!.Action === ActionType.Ban) {
            if (props.cardProps!.player!.Team === props.cardProps!.currentAction!.Team) {
                setSelfBanModalOpen(true);
                return;
            } else {
                banHero();
                return;
            }
        }

        if (props.cardProps!.currentAction!.Action === ActionType.Pick) {
            if (props.cardProps!.player!.PickedHero != null) {
                setShakeAnimation(!shakeAnimation); //Spiller shake animation
                return;
            }

            if (props.cardProps!.player!.Team !== props.cardProps!.currentAction!.Team) {
                setShakeAnimation(!shakeAnimation); //Spiller shake animation
                return;
            }
            pickHero();
        }
    }

    const selectable = props.cardProps!.player!.PickedHero || banned ? 'unselectable' : 'selectable';
    if (!context) return <></>

    return (
        <>
            <Popup
                key={props.Hero.Name}
                header={props.Hero.Name}
                content={<h5 className={`tier-${props.Hero.Tier}`} style={{ margin: 0 }}>{TierConverter(props.Hero.Tier)} Tier</h5>}
                mouseEnterDelay={1500}
                position='top center'
                on='hover'
                trigger={
                    <div>
                        <Transition
                            animation='shake'
                            duration='1200'
                            visible={shakeAnimation}
                        >
                            <Image
                                src={getHeroImage(context!.gameData.GameType, props.Hero)}
                                alt={props.Hero.Name}
                                className={selectable}
                                centered
                                style={{ width: 40 }}
                                onClick={() => OnClick()} />

                        </Transition>
                    </div>
                }
            />

            {banned &&
                <Icon size='huge' color='red' name='ban' className='hero-icon' />
            }

            <ConfirmModal
                isOpen={selfBanModalOpen}
                onAccept={() => banHero()}
                textContent={`Are you sure you want to ban your own hero?`}
                toggleOpen={setSelfBanModalOpen}
                icon={<Icon name='exclamation circle' />
                }
            />
        </>)
}